export const RCS_PROVIDERS = {
   KARIX: "KARIX",
   SMART_PING: "SMART_PING",
};
